import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Table, Button, Form, Pagination, InputGroup, Image, Modal } from 'react-bootstrap';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import { API_ENDPOINTS,IMAGE_PATH } from '../config'; // Updated import
import axios from 'axios';
import { BsPencilSquare, BsTrash, BsSearch, BsSortDown, BsSortUp } from 'react-icons/bs';

const Blogs = () => {
  const [blogs, setBlogs] = useState([]);
  const [editingBlog, setEditingBlog] = useState(null);
  const [showAddBlogModal, setShowAddBlogModal] = useState(false);
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    image: null,
    blogType: ''
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [blogsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortField, setSortField] = useState('title');
  const [sortDirection, setSortDirection] = useState('asc');

  useEffect(() => {
    fetchBlogs();
  }, []);

  const fetchBlogs = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_ENDPOINTS.fetchBlogs}`, {
        headers: { 'token': token }
      });
      setBlogs(response.data.blogs);
    } catch (error) {
      console.error('Error fetching blogs:', error);
    }
  };

  // Sorting function
  const sortBlogs = (field) => {
    if (field === sortField) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDirection('asc');
    }
  };

  // Apply sorting and filtering
  const sortedAndFilteredBlogs = blogs
    .filter(blog =>
      blog.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      blog.description.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .sort((a, b) => {
      if (a[sortField] < b[sortField]) return sortDirection === 'asc' ? -1 : 1;
      if (a[sortField] > b[sortField]) return sortDirection === 'asc' ? 1 : -1;
      return 0;
    });

  // Pagination
  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
  const currentBlogs = sortedAndFilteredBlogs.slice(indexOfFirstBlog, indexOfLastBlog);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleDeleteBlog = async (blogId) => {
    if (window.confirm('Are you sure you want to delete this blog?')) {
      try {
        const token = localStorage.getItem('token');
        await axios.delete(`${API_ENDPOINTS.deleteBlog}`, {
          headers: { 'token': token, 'blogId': blogId }
        });
        fetchBlogs();
      } catch (error) {
        console.error('Error deleting blog:', error);
      }
    }
  };

  const handleEditBlog = (blog) => {
    setEditingBlog({...blog});
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditingBlog({
      ...editingBlog,
      [name]: value
    });
  };

  const handleImageChange = (e) => {
    setEditingBlog({
      ...editingBlog,
      image: e.target.files[0]
    });
  };

  const handleEditSubmit = async () => {
    try {
      const token = localStorage.getItem('token');
      const formData = new FormData();
      formData.append('title', editingBlog.title);
      formData.append('description', editingBlog.description);
      formData.append('blogType', editingBlog.blogType);
      if (editingBlog.image) {
        formData.append('image', editingBlog.image);
      }

      await axios.patch(`${API_ENDPOINTS.editBlog}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'token': token,
          'blogId': editingBlog.blogId
        }
      });
      setEditingBlog(null);
      fetchBlogs();
    } catch (error) {
      console.error('Error updating blog:', error);
    }
  };

  const handleAddBlogChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleAddBlogImageChange = (e) => {
    setFormData({ ...formData, image: e.target.files[0] });
  };

  const handleAddBlogSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('token');
      const formDataUpload = new FormData();
      formDataUpload.append('title', formData.title);
      formDataUpload.append('description', formData.description);
      formDataUpload.append('blogType', formData.blogType);
      if (formData.image) {
        formDataUpload.append('image', formData.image);
      }

      await axios.post(`${API_ENDPOINTS.createBlog}`, formDataUpload, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'token': token
        }
      });
      fetchBlogs(); // Refresh blog list
      setShowAddBlogModal(false); // Hide modal after submission
      setFormData({
        title: '',
        description: '',
        image: null,
        blogType: ''
      });
    } catch (error) {
      console.error('Error creating blog:', error);
    }
  };
  return (
    <div style={{ display: 'flex', flexDirection: 'row', height: '100vh' }}>
      <Sidebar style={{ position: 'fixed', top: 0, bottom: 0, left: 0, width: '250px', zIndex: 1000 }} />
      <div style={{  width: 'calc(100%)', height: 'calc(100vh)', overflowY: 'auto' }}>
        <Header />
        <Container fluid className="mt-3">
          <Row>
            <Col>
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h2>Blogs</h2>
                <Button variant="primary" onClick={() => setShowAddBlogModal(true)}>
                  Add Blog
                </Button>
              </div>
              <InputGroup className="mb-3">
                <InputGroup.Text><BsSearch /></InputGroup.Text>
                <Form.Control
                  placeholder="Search blogs..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </InputGroup>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th onClick={() => sortBlogs('title')}>
                      Title {sortField === 'title' && (sortDirection === 'asc' ? <BsSortUp /> : <BsSortDown />)}
                    </th>
                    <th onClick={() => sortBlogs('description')}>
                      Description {sortField === 'description' && (sortDirection === 'asc' ? <BsSortUp /> : <BsSortDown />)}
                    </th>
                    <th onClick={() => sortBlogs('blogType')}>
                      Type {sortField === 'blogType' && (sortDirection === 'asc' ? <BsSortUp /> : <BsSortDown />)}
                    </th>
                    <th>Image</th>
                    <th>Blog ID</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {currentBlogs.map((blog) => (
                    <tr key={blog._id}>
                      {editingBlog && editingBlog._id === blog._id ? (
                        <>
                          <td>
                            <Form.Control
                              type="text"
                              name="title"
                              value={editingBlog.title}
                              onChange={handleChange}
                            />
                          </td>
                          <td>
                            <Form.Control
                              type="text"
                              name="description"
                              value={editingBlog.description}
                              onChange={handleChange}
                            />
                          </td>
                          <td>
                            <Form.Control
                              type="text"
                              name="blogType"
                              value={editingBlog.blogType}
                              onChange={handleChange}
                            />
                          </td>
                          <td>
                            <Form.Control
                              type="file"
                              name="image"
                              onChange={handleImageChange}
                            />
                          </td>
                          <td>{editingBlog.blogId}</td>
                          <td>
                            <Button variant="success" onClick={handleEditSubmit} className="me-2">Save</Button>
                            <Button variant="secondary" onClick={() => setEditingBlog(null)}>Cancel</Button>
                          </td>
                        </>
                      ) : (
                        <> 
                          <td>{blog.title.length  > 50 ?`${blog.title.substring(0, 50)}...` : blog.title } </td>
                          <td>{blog.description.length  > 50 ?`${blog.description.substring(0, 100)}...` : blog.description }</td>
                          <td>{blog.blogType}</td>
                          <td><Image src={blog.image} alt={blog.title} fluid style={{ width: '80px', height: 'auto' }} /></td>
                          <td>{blog.blogId}</td>
                          <td className="d-flex align-items-center">
                            <Button variant="info" className="me-2" onClick={() => handleEditBlog(blog)}>
                              <BsPencilSquare />
                            </Button>
                            <Button variant="danger" onClick={() => handleDeleteBlog(blog.blogId)}>
                              <BsTrash />
                            </Button>
                          </td>
                        </>
                      )}
                    </tr>
                  ))}
                </tbody>
              </Table>
              <Pagination>
                {Array.from({ length: Math.ceil(sortedAndFilteredBlogs.length / blogsPerPage) }).map((_, index) => (
                  <Pagination.Item key={index + 1} active={index + 1 === currentPage} onClick={() => paginate(index + 1)}>
                    {index + 1}
                  </Pagination.Item>
                ))}
              </Pagination>
            </Col>
          </Row>
        </Container>
        <Modal show={showAddBlogModal} onHide={() => setShowAddBlogModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Add New Blog</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={handleAddBlogSubmit}>
              <Form.Group controlId="formTitle">
                <Form.Label>Title</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter blog title"
                  name="title"
                  value={formData.title}
                  onChange={handleAddBlogChange}
                  required
                />
              </Form.Group>
              <Form.Group controlId="formDescription" className="mt-2">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Enter blog description"
                  name="description"
                  value={formData.description}
                  onChange={handleAddBlogChange}
                  required
                />
              </Form.Group>
              <Form.Group controlId="formBlogType" className="mt-2">
              <Form.Control
                  as="select"
                  name="blogType"
                  value={formData.blogType}
                  onChange={handleAddBlogChange}
                  required
                >
                  <option value="">Select Blog Type</option>
                  <option value="Education">Education</option>
                  <option value="Health">Health</option>
                </Form.Control>
              </Form.Group>
              <Form.Group controlId="formImage" className="mt-2">
                <Form.Label>Image</Form.Label>
                <Form.Control
                  type="file"
                  onChange={handleAddBlogImageChange}
                  required
                />
              </Form.Group>
              <Button variant="primary" type="submit" className="mt-3">
                Add Blog
              </Button>
            </Form>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
};

export default Blogs;